// @ts-nocheck

// eslint-disable-next-line
String.prototype.cap = function () {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

// eslint-disable-next-line
export default null
